"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNullableDateAsStringValue = exports.isOptimizedDateRangeValue = exports.isDateRangeValue = exports.isTimeValue = exports.isOptimizedDateValue = exports.isDateAsStringValue = exports.isDateValue = void 0;
const objects_1 = require("../type-checking/objects");
const typing_1 = require("../type-checking/typing");
const primitives_1 = require("../type-checking/primitives");
const string_1 = require("./string");
const isDateValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        date: (0, typing_1.Union)(exports.isDateAsStringValue, string_1.isEmptyStringValue, primitives_1.isNullValue),
        include_time: primitives_1.isBooleanValue,
    });
};
exports.isDateValue = isDateValue;
const isDateAsStringValue = (fieldValue) => {
    if (!(0, primitives_1.isStringValue)(fieldValue))
        return false;
    return !isNaN(Date.parse(fieldValue));
};
exports.isDateAsStringValue = isDateAsStringValue;
const isOptimizedDateValue = (fieldValue) => {
    return (0, exports.isDateAsStringValue)(fieldValue);
};
exports.isOptimizedDateValue = isOptimizedDateValue;
/**
 * Checks if a value is a valid time string
 *
 * @param fieldValue
 *
 * ^ - Start of the string
 * ( - Start of the capturing group
 * [0-1]?[0-9] - Matches the hour in 12-hour format (00-19 or 20-23)
 * | - Or
 * 2[0-3] - Matches the hour in 24-hour format (20-23)
 * ) - End of the capturing group
 * : - Matches the colon between hours and minutes
 * [0-5][0-9] - Matches the minutes (00-59)
 * (:[0-5]?[0-9])? - Matches an optional seconds (00-59)
 * \s? - Matches an optional whitespace character
 * (?:AM|PM)? - Matches an optional AM or PM
 * $ - End of the string
 * /i - Case-insensitive matching
 */
const isTimeValue = (fieldValue) => {
    if (!(0, primitives_1.isStringValue)(fieldValue))
        return false;
    const timeStringRegExp = /^([0-1]?[0-9]|2[0-3]):([0-5]?[0-9])(:[0-5]?[0-9])?\s?(?:AM|PM)?$/;
    return timeStringRegExp.test(fieldValue);
};
exports.isTimeValue = isTimeValue;
const isDateRangeValue = (fieldValue) => {
    return (0, objects_1.isValidObjectValue)(fieldValue, {
        from_date: exports.isDateValue,
        to_date: exports.isDateValue,
    });
};
exports.isDateRangeValue = isDateRangeValue;
const isOptimizedDateRangeValue = (fieldValue) => {
    return ((0, objects_1.isValidObjectValue)(fieldValue, {
        from_date: exports.isDateAsStringValue,
        to_date: exports.isDateAsStringValue,
    }, true) || (0, exports.isDateAsStringValue)(fieldValue));
};
exports.isOptimizedDateRangeValue = isOptimizedDateRangeValue;
const isNullableDateAsStringValue = (fieldValue) => {
    return (0, typing_1.Union)(exports.isDateAsStringValue, primitives_1.isNullValue)(fieldValue);
};
exports.isNullableDateAsStringValue = isNullableDateAsStringValue;
